import type { TWorkJourneyManagementTab } from '@src/models/interfaces/workJourneyManagement.interface';

export { ATTENDANCE_DASHBOARD_STATES } from '@src/packages/workJourney/constants';

export const WORK_JOURNEY_MANAGEMENT_TABS: TWorkJourneyManagementTab[] = [
  'requires_attention',
  'journeys',
  'calendar',
];

/** sessionStorage key for the last active Gestión de Jornadas tab. */
export const WORK_JOURNEY_MANAGEMENT_ACTIVE_TAB_STORAGE_KEY = 'workJourney.management.activeTab';

/** sessionStorage key for management list filters (status/user/shift/journey — not month). */
export const WORK_JOURNEY_MANAGEMENT_FILTERS_STORAGE_KEY = 'workJourney.management.filters';

export const WORK_JOURNEY_MANAGEMENT_DEFAULT_TAB: TWorkJourneyManagementTab =
  WORK_JOURNEY_MANAGEMENT_TABS[0];

export const WORK_JOURNEY_MANAGEMENT_JOURNEY_FILTER_ALL = 'all';

export const isWorkJourneyManagementTab = (value: unknown): value is TWorkJourneyManagementTab =>
  typeof value === 'string' && (WORK_JOURNEY_MANAGEMENT_TABS as readonly string[]).includes(value);

export const WORK_JOURNEY_ATTENTION_TABLE_COLUMN_WIDTH = {
  DATE: 110,
  JOURNEY: 140,
  REASON: 120,
} as const;

export const WORK_JOURNEY_JOURNEYS_TABLE_COLUMN_WIDTH = {
  MONTH_STATUS: 200,
  SHIFT: 160,
  COVERAGE: 90,
  ACTIONS: 48,
} as const;

/** Default page size for the Journeys tab table (`listJourneys`). */
export const WORK_JOURNEY_JOURNEYS_PAGE_SIZE = 10;

/** Default page size for the Attention tab table (`listAttention`). */
export const WORK_JOURNEY_ATTENTION_PAGE_SIZE = 10;

/** Default page size for calendar day report journeys (`listDayReport`). */
export const WORK_JOURNEY_DAY_REPORT_PAGE_SIZE = 10;

/** Max journey options shown in the management filter Select (search still scans all). */
export const WORK_JOURNEY_MANAGEMENT_JOURNEY_FILTER_OPTIONS_LIMIT = 10;

/** Org-user Elastic search for the management user filter. */
export const WORK_JOURNEY_MANAGEMENT_USER_FILTER_MIN_SEARCH_LENGTH = 3;
export const WORK_JOURNEY_MANAGEMENT_USER_FILTER_DEBOUNCE_MS = 500;
